var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('Cookies',{attrs:{"color_one":"#d89747","color_two":"white","websitename":"vie-economique-gimont.fr"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }